<template>
  <div>
    <v-list-item class="grey lighten-3" ripple @click="OnSelected">
      <v-list-item-action>
        <v-icon :color="selected.length > 0 ? 'indigo darken-4' : ''">
          {{ icon }}
        </v-icon>
      </v-list-item-action>
      <v-list-item-content>
        <v-list-item-title>
          Select All
        </v-list-item-title>
      </v-list-item-content>
    </v-list-item>
    <v-divider class="mt-2"></v-divider>
  </div>
</template>
<script>
export default {
  props: {
    selected: { type: Array, required: true },
    items: { type: Array, required: true },
    toggle: { type: Function, required: true },
  },
  computed: {
    isSelectedAll() {
      return this.selected.length === this.items.length;
    },
    isSelected() {
      return this.selected.length > 0 && !this.isSelectedAll;
    },
    icon() {
      if (this.isSelectedAll) return "fas fa-check-square";
      if (this.isSelected) return "fas fa-minus-square";
      return "far fa-square";
    },
  },
  methods: {
    OnSelected() {
      this.toggle();
    },
  },
};
</script>
